import './style.scss';
import SocialButton from './socialbutton.js';

export default SocialButton;